import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "../../request.js";
import { fromJSON as e } from "../../geometry/support/jsonUtils.js";
import { parseUrl as o, asValidOptions as s } from "../utils.js";

function r(r, i, n) {
  var p = i.map(function (t) {
    return t.toJSON();
  }),
      a = i[0].spatialReference,
      f = o(r),
      l = _objectSpread(_objectSpread({}, f.query), {}, {
    f: "json",
    sr: a.wkid ? a.wkid : JSON.stringify(a.toJSON()),
    polygons: JSON.stringify(p)
  }),
      m = s(l, n);

  return t(f.path + "/labelPoints", m).then(function (_ref) {
    var t = _ref.data;
    return (t.labelPoints || []).map(function (t) {
      return e(t).set({
        spatialReference: a
      });
    });
  });
}

export { r as labelPoints };